import angular from 'angular';
import uiRouter from 'angular-ui-router';
import pageComponent from './page.component';
import aboutComponent from './page-about.component';
import privacyComponent from './page-privacy.component';
import cidComponent from './page-cid.component';
import pageService from './page.service';
import homeAppComponent from './page-home-app.component'

import videoService from './video.service';
import homeVideoComponent from './page-home-video.component'
import newHomeVideoComponent from './page-new-home-video.component'

let pageModule = angular.module('page', [
  uiRouter
])

.service('Page', pageService)
.service('Video', videoService)

.config(($stateProvider, $urlRouterProvider) => {
  "ngInject";

  $stateProvider
    .state('page', {
      component: 'page'
    })
    .state('page.home-app', {
      url: '/page/custom-home-app',
      component: 'homeApp',
    })
    .state('page.video-home', {
      url: '/page/video-home',
      component: 'homeVideoComponent',
      params: {
        name: 'about'
      }
    })
    .state('page.new-video-home', {
      url: '/page/video-home/new',
      component: 'newHomeVideoComponent',
    })
    .state('page.view-video-home', {
      url: '/page/video-home/:id',
      component: 'newHomeVideoComponent',
      params: {
        name: ''
      }
    })
    .state('page.about', {
      url: '/page/about',
      component: 'about',
      params: {
        name: 'about'
      }
    })
    .state('page.privacy', {
      url: '/page/privacy',
      component: 'privacy',
      params: {
        name: 'privacy'
      }
    })
    .state('page.cid', {
      url: '/page/cid',
      component: 'cid',
      params: {
        name: 'cid'
      }
    });
})

.component('page', pageComponent)
.component('about', aboutComponent)
.component('privacy', privacyComponent)
.component('cid', cidComponent)
.component('homeApp', homeAppComponent)
.component('homeVideoComponent', homeVideoComponent)
.component('newHomeVideoComponent', newHomeVideoComponent)
.name;

export default pageModule;



// WEBPACK FOOTER //
// ./client/app/components/page/page.js